module.exports = __webpack_public_path__ + "static/media/2.4d8b5320.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/lida/2.JPG
// module id = 537
// module chunks = 0